<template>
  <div class="skilled-knowledge-section">
    <h3 class="section-title">擅长知识</h3>

    <div class="knowledge-grid">
      <!-- 知识卡片 -->
      <div class="knowledage-card-container" v-for="(knowledge, index) in knowledgeList" :key="knowledge.id">
        <div class="knowledge-card">
          <div class="knowledge-header">
            <img class="knowledge-icon" src="/img/boshi-icon.png" />
            <h4 class="knowledge-title">{{ knowledge.name }}</h4>
          </div>
          <div class="knowledge-content">
            <el-popover placement="top-start" width="300" trigger="hover">
              <div class="popover-content">
                <p>{{ knowledge.content }}</p>
              </div>
              <p slot="reference" class="knowledge-description">{{ knowledge.content }}</p>
            </el-popover>
          </div>
        </div>
        <!-- 操作按钮 -->
        <div class="knowledge-actions" v-if="isShowBtn">
          <!-- <el-button
            type="text"
            size="mini"
            @click="moveKnowledge(index, 'prev')"
            :disabled="index === 0"
            class="action-btn"
          >
            <i class="el-icon-arrow-left"></i>
          </el-button> -->
          <img src="/img/left-icon.png" alt="" class="arrow-left-icon" @click="moveKnowledge(index, 'prev')" />
          <img src="/img/right-icon.png" alt="" class="arrow-right-icon" @click="moveKnowledge(index, 'next')" />
          <img src="/img/del.png" alt="" class="delete-icon" @click="deleteKnowledge(knowledge.id)" />
          <!-- <el-button type="text" size="mini" class="action-btn delete-btn">
            <i class="el-icon-close"></i>
          </el-button> -->
        </div>
      </div>

      <!-- 添加知识按钮 -->
      <div v-if="knowledgeList.length < 20 && isShowBtn" class="add-knowledge-card" @click="openAddDialog">
        <img class="add-icon" src="/img/add-skill.png" alt="" />
        <span class="add-text">添加知识</span>
      </div>
    </div>

    <!-- 新增知识弹窗 -->
    <el-dialog
      :visible.sync="showAddDialog"
      :title="dialogTitle"
      width="600px"
      :before-close="handleClose"
      @close="handleCloseDialog"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class="custom-dialog"
    >
      <el-form :model="knowledgeForm" :rules="formRules" ref="knowledgeForm" label-width="120px">
        <el-form-item label="知识" prop="name">
          <el-input v-model="knowledgeForm.name" placeholder="请输入知识" maxlength="30" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="擅长描述" prop="content">
          <el-input
            v-model="knowledgeForm.content"
            type="textarea"
            :rows="4"
            placeholder="请输入擅长描述"
            maxlength="300"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleAddKnowledge" :loading="saving" class="submit-btn">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getKnowledgeList, addKnowledge, deleteKnowledge, updateKnowledgeOrder} from '@/api/consultingService'

export default {
  name: 'SkilledKnowledge',
  props: {
    consultantId: {
      type: [String, Number],
      required: true
    },
    isShowBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      knowledgeList: [],
      showAddDialog: false,
      saving: false,
      knowledgeForm: {
        name: '',
        content: ''
      },
      formRules: {
        name: [
          {required: true, message: '请输入知识', trigger: 'blur'},
          {min: 1, max: 30, message: '知识长度在1到30个字符', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入擅长描述', trigger: 'blur'},
          {min: 50, max: 300, message: '擅长描述长度在50到300个字符', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    // 弹层标题（带图标）
    dialogTitle() {
      return '新增擅长知识'
    }
  },
  created() {
    this.loadKnowledgeList()
  },
  methods: {
    // 加载知识列表
    async loadKnowledgeList() {
      try {
        const response = await getKnowledgeList(this.consultantId)
        if (response.code === 200) {
          // 按sequenceNum升序排列
          this.knowledgeList = (response.data || []).sort((a, b) => a.sequenceNum - b.sequenceNum)
          this.$emit('knowledge-updated', this.knowledgeList)
        }
      } catch (error) {
        console.error('加载知识列表失败:', error)
        this.$message.error('加载知识列表失败')
      }
    },

    // 打开新增弹窗
    openAddDialog() {
      if (this.knowledgeList.length >= 20) {
        this.$message.warning('最多允许20个知识')
        return
      }
      this.showAddDialog = true
    },

    // 关闭弹窗
    handleCloseDialog() {
      this.showAddDialog = false
      this.$refs.knowledgeForm?.resetFields()
      this.knowledgeForm = {name: '', content: ''}
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },

    // 新增知识
    async handleAddKnowledge() {
      try {
        await this.$refs.knowledgeForm.validate()

        // 再次检查知识数量
        if (this.knowledgeList.length >= 20) {
          this.$message.warning('最多允许20个知识')
          return
        }

        this.saving = true
        const response = await addKnowledge({
          consultantId: this.consultantId,
          name: this.knowledgeForm.name,
          content: this.knowledgeForm.content
        })

        if (response.code === 200) {
          this.$message.success('新增成功')
          this.handleCloseDialog()
          this.loadKnowledgeList()
        } else {
          this.$message.error(response.msg || '新增失败')
        }
      } catch (error) {
        console.error('新增知识失败:', error)
        this.$message.error('新增失败')
      } finally {
        this.saving = false
      }
    },

    // 移动知识位置
    async moveKnowledge(index, direction) {
      try {
        let targetIndex

        if (direction === 'prev') {
          targetIndex = index - 1
        } else {
          targetIndex = index + 1
        }

        if (targetIndex < 0 || targetIndex >= this.knowledgeList.length) {
          return
        }

        // 创建新的排序数组并交换位置
        const newOrder = [...this.knowledgeList]
        const temp = newOrder[index]
        newOrder[index] = newOrder[targetIndex]
        newOrder[targetIndex] = temp

        // 提取knowledgeIds数组
        const knowledgeIds = newOrder.map(item => item.id)

        const response = await updateKnowledgeOrder({
          knowledgeIds,
          consultantId: this.consultantId
        })

        if (response.code === 200) {
          this.$message.success('移动成功')
          this.loadKnowledgeList()
        } else {
          this.$message.error(response.msg || '移动失败')
        }
      } catch (error) {
        console.error('移动知识失败:', error)
        this.$message.error('移动失败')
      }
    },

    // 删除知识
    async deleteKnowledge(knowledgeId) {
      try {
        await this.$confirm('确定要删除这条知识吗？', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const response = await deleteKnowledge({
          consultantId: this.consultantId,
          knowledgeId
        })

        if (response.code === 200) {
          this.$message.success('删除成功')
          this.loadKnowledgeList()
        } else {
          this.$message.error(response.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除知识失败:', error)
          this.$message.error('删除失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .popover-content {
  max-width: 300px;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  line-height: 1.5;

  p {
    margin: 0;
    font-size: 14px;
    color: #333;
  }
}
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 24px 40px 20px;
    border-bottom: none;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;

      &::before {
        content: '';
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url('/img/xinzeng.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 40px;
    }
  }

  .el-dialog__body {
    padding: 24px 60px;
  }

  .el-dialog__footer {
    padding: 20px 40px 32px;
    border-top: none;
  }

  .el-form {
    .el-form-item {
      margin-bottom: 24px;

      .el-form-item__label {
        font-size: 16px;
        color: #333;
        font-weight: 500;
        padding-bottom: 8px;
        text-align: left;
      }

      .el-form-item__content {
        .el-select,
        .el-input,
        .el-textarea {
          width: 100%;
        }
      }
    }
  }
}

.skilled-knowledge-section {
  width: 1200px;
  padding: 32px;
  box-sizing: border-box;
  margin-top: 32px;
  background: #fff;
  border-radius: 8px;

  .section-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 24px;
  }

  .knowledge-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 24px;
    column-gap: 53px;

    .knowledge-card {
      background: #f1f1f1;
      border-radius: 8px;
      padding: 16px;
      position: relative;
      min-height: 120px;

      .knowledge-header {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .knowledge-icon {
          margin-right: 8px;
          width: 32px;
          height: 32px;
          position: relative;
          top: -3px;

          i {
            font-size: 20px;
            color: #5ad3cd;
          }
        }

        .knowledge-title {
          font-weight: 600;
          font-size: 18px;
          color: #333333;
          margin: 0;
          line-height: 1.4;
        }
      }

      .knowledge-content {
        position: relative;

        .knowledge-description {
          position: relative;
          font-weight: 400;
          font-size: 18px;
          color: #333333;
          line-height: 1.5;
          margin: 0;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          cursor: pointer;
        }
      }
    }
    .knowledge-actions {
      // position: absolute;
      // bottom: 8px;
      // right: 8px;
      display: flex;
      justify-content: flex-end;
      margin-top: 8px;
      cursor: pointer;
      gap: 11px;
      .arrow-left-icon {
        width: 24px;
        height: 24px;
      }
      .arrow-right-icon {
        width: 24px;
        height: 24px;
      }
      .delete-icon {
        width: 24px;
        height: 24px;
      }
    }

    .add-knowledge-card {
      background: #fff;
      border: 1px solid #5ad3cd;
      border-radius: 8px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      min-height: 120px;
      transition: all 0.3s;

      &:hover {
        border-color: #40a9ff;
        background: #f6ffed;
      }

      .add-icon {
        margin-bottom: 8px;
        width: 32px;
        height: 32px;
        i {
          font-size: 32px;
          color: #5ad3cd;
        }
      }

      .add-text {
        font-size: 16px;
        color: #5ad3cd;
        font-weight: 500;
      }
    }
  }
}

.dialog-footer {
  text-align: center;
  padding: 0;

  .submit-btn {
    width: 60%;
    height: 48px;
    font-size: 18px;
    font-weight: 500;
    border-radius: 8px;
    background: #5ad3cd;
    border-color: #5ad3cd;

    &:hover {
      background: #4ab8b2;
      border-color: #4ab8b2;
    }
  }
}
</style>
